import {useState, lazy, useEffect} from 'react';
import {AppBar, Toolbar, Container, useTheme} from '@mui/material';
import {HamburgerMenu, HamburgerMenuNew} from '@jobseeker/lotus/icons';
import {Box} from '@jobseeker/lotus/foundations';
import ImageHolder from '@jobseeker/lotus/components/ImageHolder';
import {Image} from '@jobseeker/lotus/components/Image';
import {ImageholderVariants} from '@jobseeker/lotus/components/ImageHolder/enums';
import MenuDrawer from '@jobseeker/lotus/components/MenuDrawer';

import type {Props} from './types';
import InfoBanner from '@jobseeker/lotus/components/InfoBanner';
import {
  handleTracking,
  deferTask,
  TrackEventUBA,
  getUbaPageName,
} from '@jobseeker/common-core/utils';

const Header = (props: Props) => {
  const {
    children = <></>,
    container = {},
    imageProps = {
      variant: ImageholderVariants.DEFAULT,
    },
    appBarProps = {},
    config: {showLogo = true},
    OnLogoutBtnClick,
    showMenu,
    others = [],
    proMeta,
    reCap,
    page,
    isMobileDevice,
    savedJobCount,
    registrationEndDate,
    handleMenuLogin,
  } = props || {};
  const [showBanner, setShowBanner] = useState(false);

  const {
    id,
    name,
    email,
    phone,
    countryCode,
    picUrl,
    phoneVerified,
    percentage,
    proMembership,
    followUpsRemaining,
    showSpotLight,
    subscriptions,
    appliedJobCount,
    interviewSlots,
  } = props?.profileInfo || {
    id: null,
    name: '',
    email: '',
    phone: '',
    countryCode: 0,
    picUrl: '',
    phoneVerified: false,
    proMembership: {
      isValid: false,
      daysLeft: 0,
    },
    followUpsRemaining: 0,
  };

  const theme = useTheme();

  const [openMenuDrawer, setMenuDrawerOpen] = useState(false);

  const handleMenuDrawer = (open: boolean) => {
    setMenuDrawerOpen(open);
  };

  const handleBannerClose = () => {
    localStorage.setItem('HIDE_INFO_BANNER', '1');
    setShowBanner(false);
    trackBannerClose();
  };

  const trackBannerView = () => {
    setTimeout(() => {
      const userId = sessionStorage.getItem('userId');
      handleTracking('jsViewNewLaunchBanner', {
        event_category: 'Banner',
        UserId: sessionStorage.getItem('userId') || 'NA',
        Device: sessionStorage.getItem('device') || 'desktop',
        Device_Type: sessionStorage.getItem('deviceType') || 'web',
        Status: sessionStorage.getItem('status') || 'LoggedOut',
      });
    }, 3000);
  };

  const trackBannerClose = () => {
    setTimeout(() => {
      const userId = sessionStorage.getItem('userId');
      handleTracking('jsCloseNewLaunchBanner', {
        event_category: 'Banner',
        UserId: sessionStorage.getItem('userId') || 'NA',
        Device: sessionStorage.getItem('device') || 'desktop',
        Device_Type: sessionStorage.getItem('deviceType') || 'web',
        Status: sessionStorage.getItem('status') || 'LoggedOut',
      });
    }, 3000);
  };

  useEffect(() => {
    const hideBanner = localStorage.getItem('HIDE_INFO_BANNER');
    if (hideBanner) {
      console.log('in hide banner condition');
      setShowBanner(false);
    } else if (page?.indexOf('epoch') > -1) {
      console.log('In Epoch Condition');
      setShowBanner(true);
    } else {
      setShowBanner(false);
      trackBannerView();
    }
  }, []);

  const sendEvent = (eventName: string, action: string) => {
    handleTracking(`${eventName}_${action}`, {
      event_category: 'App_Promotion',
      Origin: page,
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
      Status: sessionStorage.getItem('status') || 'LoggedOut',
    });
  };

  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  return (
    <AppBar {...appBarProps}>
      {/* {showBanner && process.env.NEXT_PUBLIC_BANNER_ENABLED === 'true' && (
        <InfoBanner
          info="Introducing the all-new iimjobs.com, crafted to simplify your job search!"
          onClose={handleBannerClose}
        />
      )} */}
      {showBanner && registrationEndDate && (
        <InfoBanner
          info={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {registrationEndDate && (
                <>
                  <Image
                    src={
                      'https://static.iimjobs.com/epoch/static/assets/reminder-calendar.svg'
                    }
                    alt={'calendar'}
                    width={18}
                    height={18}
                    style={{marginRight: 8, position: 'relative', bottom: 3}}
                  />
                  {`Registrations ends on ${registrationEndDate}! Hurry up`}
                </>
              )}
            </Box>
          }
          onClose={handleBannerClose}
        />
      )}
      <Container {...container}>
        <Toolbar disableGutters>
          {showMenu && (
            <>
              <Box
                display={{xxs: 'block', lg: 'none'}}
                mr={theme.spacing(2)}
                onClick={() => {
                  deferTask(() => {
                    handleMenuDrawer(true);
                    sendEvent('DownloadAppBtnMwebHamburger', 'View');
                    TrackEventUBA('topMenuClick', 'click', {
                      section: 'Hamburger',
                      page: getUbaPageName(),
                      sessionUsername: sessionStorage.getItem('userId') || '',
                      clickedMenuName: 'Hamburger',
                    });
                  });
                }}
              >
                <Image
                  src={isAppIimjobs ? HamburgerMenu : HamburgerMenuNew}
                  alt={'HamburgerMenu'}
                  data-testid="menu_mobile"
                  data-name="menu_mobile"
                  width={isAppIimjobs ? 16 : 18}
                  height={isAppIimjobs ? 16 : 18}
                  objectFit="cover"
                  quality={50}
                  style={{marginRight: 0.5}}
                />
              </Box>

              {/* Added menu drawer */}

              {showMenu && isMobileDevice && (
                <MenuDrawer
                  theme={theme}
                  handleDrawer={handleMenuDrawer}
                  openDrawer={openMenuDrawer}
                  name={name}
                  email={email}
                  phone={phone}
                  countryCode={countryCode}
                  phoneVerified={phoneVerified}
                  profileProgress={percentage}
                  profilePicUrl={picUrl}
                  proMembership={proMembership}
                  OnLogoutBtnClick={OnLogoutBtnClick}
                  followUps={followUpsRemaining}
                  profileDrawerOptions={props?.profileDrawerOptions}
                  tabsList={props?.tabsList}
                  aboutSection={others}
                  proMeta={proMeta}
                  reCap={reCap}
                  page={page}
                  savedJobCount={savedJobCount}
                  sendEvent={sendEvent}
                  showSpotLight={!!showSpotLight}
                  subscriptions={subscriptions}
                  appliedJobCount={appliedJobCount}
                  interviewSlots={interviewSlots}
                  loginHandler={handleMenuLogin}
                />
              )}
            </>
          )}
          {showLogo && (
            <Box display={'flex'} height={34}>
              <ImageHolder {...imageProps} />
            </Box>
          )}
          {children}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
